import { Component, Input } from '@angular/core';

@Component({
  selector: 'progress-bar',
  templateUrl: 'progress-bar.html',
})
export class ProgressBarComponent {
  @Input('progress') progress;
  @Input('title') title;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/progress-bar/progress-bar.ts